(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.section =
        this.closest('.section-header') ||
        this.closest('.shopify-section') ||
        document.querySelector('.section-header') ||
        document.querySelector('.shopify-section-group-header-group');

      this.debug =
        (typeof window !== 'undefined' &&
          ((window.Shopify && Shopify.designMode) ||
          ((window.localStorage && window.localStorage.getItem('debugStickyHeader') === '1') ||
            new URLSearchParams(window.location.search).has('debugStickyHeader')))) ||
        false;

      if (this.debug) {
        console.log('[StickyHeader] connected', {
          stickyType: this.getAttribute('data-sticky-type'),
          sectionFound: !!this.section,
          sectionClassName: this.section ? this.section.className : null,
        });
      }

      if (!this.section) return;
      if (!window.addEventListener) return;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      const mql = window.matchMedia('(max-width: 990px)');
      if (mql && mql.addEventListener) {
        mql.addEventListener('change', this.setHeaderHeight.bind(this));
      } else if (mql && mql.addListener) {
        mql.addListener(this.setHeaderHeight.bind(this));
      }

      if (this.headerIsAlwaysSticky) {
        this.section.classList.add('shopify-section-header-sticky');
      }

      this.scroller = document.scrollingElement || document.documentElement;
      this.activeScroller = this.scroller;
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.debugScrollCount = 0;
      this.drawerActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.onAnyScrollHandler = (event) => {
        if (this.drawerActive) return;
        if (!event || !event.target) return;
        const target = event.target;
        if (target === document || target === document.documentElement || target === document.body) return;
        if (!(target instanceof Element)) return;
        if (target.scrollHeight <= target.clientHeight) return;
        if (this.activeScroller !== target) {
          this.activeScroller = target;
          this.currentScrollTop = this.getScrollTop();
          if (this.debug) {
            console.log('[StickyHeader] activeScroller changed', {
              tag: target.tagName,
              className: target.className,
              id: target.id,
            });
          }
        }
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      document.addEventListener('scroll', this.onAnyScrollHandler, true);
      document.addEventListener('scroll', this.onScrollHandler, true);

      this.onDrawerToggleHandler = this.onDrawerToggle.bind(this);
      document.addEventListener('drawer:toggle', this.onDrawerToggleHandler);
      this.onDetailsToggleHandler = this.onDetailsToggle.bind(this);
      document.addEventListener('toggle', this.onDetailsToggleHandler, true);
      this.syncDrawerState();
    }

    setHeaderHeight() {
      this.headerHeight = this.offsetHeight || 0;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      if (this.debug) console.log('[StickyHeader] setHeaderHeight', { headerHeight: this.headerHeight });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('scroll', this.onAnyScrollHandler, true);
      document.removeEventListener('scroll', this.onScrollHandler, true);
      if (this.onDrawerToggleHandler) document.removeEventListener('drawer:toggle', this.onDrawerToggleHandler);
      if (this.onDetailsToggleHandler) document.removeEventListener('toggle', this.onDetailsToggleHandler, true);
    }

    isMenuDrawerOpen() {
      const menuOpen = document.querySelector('menu-drawer details[open], header-drawer details[open]');
      const dropdownOpen = document.getElementById('Details-menu-drawer-dropdown')?.hasAttribute('open');
      return !!(menuOpen || dropdownOpen);
    }

    syncDrawerState() {
      const shouldBeActive = this.isMenuDrawerOpen();
      if (shouldBeActive === this.drawerActive) return;
      this.drawerActive = shouldBeActive;
      if (this.drawerActive) {
        this.preventHide = true;
        this.preventReveal = false;
        this.activeScroller = this.scroller;
        this.currentScrollTop = this.getScrollTop();
        this.section.classList.add('drawer-active', 'shopify-section-header-sticky');
        this.section.classList.remove('shopify-section-header-hidden');
      } else {
        this.preventHide = false;
        this.activeScroller = this.scroller;
        this.currentScrollTop = this.getScrollTop();
        requestAnimationFrame(() => this.onScroll());
        this.section.classList.remove('drawer-active');
      }
    }

    onDrawerToggle() {
      this.syncDrawerState();
    }

    onDetailsToggle(event) {
      const target = event && event.target;
      if (!(target instanceof HTMLDetailsElement)) return;
      if (
        target.matches('#Details-menu-drawer-dropdown') ||
        target.matches('menu-drawer details') ||
        target.matches('header-drawer details')
      ) {
        requestAnimationFrame(() => this.syncDrawerState());
      }
    }

    getScrollTop() {
      if (!this.activeScroller) return window.pageYOffset || document.documentElement.scrollTop || 0;
      if (this.activeScroller === document.documentElement || this.activeScroller === document.body) {
        return window.pageYOffset || document.documentElement.scrollTop || 0;
      }
      return this.activeScroller.scrollTop || 0;
    }

    onScroll() {
      const scrollTop = this.getScrollTop();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (this.drawerActive) {
        this.section.classList.add('shopify-section-header-sticky');
        this.section.classList.remove('shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }

      const threshold = typeof this.headerHeight === 'number' ? this.headerHeight : this.offsetHeight;
      if (this.debug && this.debugScrollCount < 25) {
        this.debugScrollCount += 1;
        console.log('[StickyHeader] onScroll', {
          scrollTop,
          currentScrollTop: this.currentScrollTop,
          threshold,
          preventHide: !!this.preventHide,
          preventReveal: !!this.preventReveal,
        });
      }

      if (scrollTop > this.currentScrollTop && scrollTop > threshold) {
        this.section.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > threshold) {
        this.section.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= threshold) {
        this.section.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.drawerActive) return;
      if (this.debug) console.log('[StickyHeader] hide');
      this.section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.drawerActive) return;
      if (this.debug) console.log('[StickyHeader] reveal');
      this.section.classList.add('shopify-section-header-sticky', 'animate');
      this.section.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.drawerActive) return;
      if (this.debug) console.log('[StickyHeader] reset');
      this.section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  if (window.customElements && !customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  (() => {
    if (typeof window === 'undefined') return;
    if (window.customElements && window.customElements.get && window.customElements.get('sticky-header')) return;
    const debug =
      (window.Shopify && Shopify.designMode) ||
      (window.localStorage && window.localStorage.getItem('debugStickyHeader') === '1') ||
      new URLSearchParams(window.location.search).has('debugStickyHeader');

    const init = () => {
      const stickyEl = document.querySelector('sticky-header[data-sticky-type]');
      if (!stickyEl) {
        if (debug) console.log('[StickyHeaderFallback] no sticky-header element found');
        return;
      }

      const section =
        stickyEl.closest('.section-header') ||
        stickyEl.closest('.shopify-section') ||
        document.querySelector('.section-header') ||
        document.querySelector('.shopify-section-group-header-group');

      if (!section) {
        if (debug) console.log('[StickyHeaderFallback] no section found');
        return;
      }

      const stickyType = stickyEl.getAttribute('data-sticky-type') || 'none';
      if (debug) console.log('[StickyHeaderFallback] init', { stickyType, sectionClassName: section.className });
      if (stickyType === 'none') return;
      if (stickyType === 'always' || stickyType === 'reduce-logo-size') {
        section.classList.add('shopify-section-header-sticky');
        return;
      }

      let headerHeight = stickyEl.offsetHeight || section.offsetHeight || 0;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

      let activeScroller = document.scrollingElement || document.documentElement;
      let lastScrollTop = activeScroller.scrollTop || window.pageYOffset || 0;
      let logCount = 0;

      const getScrollTop = () => {
        if (!activeScroller) return window.pageYOffset || document.documentElement.scrollTop || 0;
        if (activeScroller === document.documentElement || activeScroller === document.body) {
          return window.pageYOffset || document.documentElement.scrollTop || 0;
        }
        return activeScroller.scrollTop || 0;
      };

      const onAnyScroll = (event) => {
        const target = event && event.target;
        if (target && target !== document && target !== document.documentElement && target !== document.body && target instanceof Element) {
          if (target.scrollHeight > target.clientHeight) activeScroller = target;
        }
      };

      const onScroll = () => {
        headerHeight = stickyEl.offsetHeight || section.offsetHeight || headerHeight || 0;
        const scrollTop = getScrollTop();
        const threshold = headerHeight;

        if (debug && logCount < 40) {
          logCount += 1;
          console.log('[StickyHeaderFallback] scroll', {
            scrollTop,
            lastScrollTop,
            threshold,
            activeScroller: activeScroller === document.documentElement ? 'documentElement' : activeScroller.tagName,
          });
        }

        if (scrollTop > lastScrollTop && scrollTop > threshold) {
          section.classList.add('scrolled-past-header');
          section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        } else if (scrollTop < lastScrollTop && scrollTop > threshold) {
          section.classList.add('scrolled-past-header');
          section.classList.add('shopify-section-header-sticky', 'animate');
          section.classList.remove('shopify-section-header-hidden');
        } else if (scrollTop <= threshold) {
          section.classList.remove('scrolled-past-header');
          section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }

        lastScrollTop = scrollTop;
      };

      window.removeEventListener('scroll', onScroll);
      window.addEventListener('scroll', onScroll, { passive: true });
      document.removeEventListener('scroll', onAnyScroll, true);
      document.addEventListener('scroll', onAnyScroll, true);
      document.removeEventListener('scroll', onScroll, true);
      document.addEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', onScroll);
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', init);
      document.addEventListener('shopify:section:reorder', init);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
